'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { accountDayAt } from '@/lib/streaks/account-day';

/** Repaint day-dependent UI at a minute boundary, including midnight and tab resume. */
export function useStreakDay(timezone) {
  const $ = _c(6);
  const [now, setNow] = useState(_temp);
  let t0;
  let t1;
  if ($[0] !== now) {
    t0 = () => {
      const update = () => {
        setNow(Date.now());
      };
      const timer = setTimeout(update, 60000 - now % 60000);
      window.addEventListener("focus", update);
      document.addEventListener("visibilitychange", update);
      return () => {
        clearTimeout(timer);
        window.removeEventListener("focus", update);
        document.removeEventListener("visibilitychange", update);
      };
    };
    t1 = [now];
    $[0] = now;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== now || $[4] !== timezone) {
    t2 = timezone === undefined ? null : accountDayAt(timezone, now);
    $[3] = now;
    $[4] = timezone;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp() {
  return Date.now();
}